<div #tooltip class="mat-tooltip" [ngClass]="tooltipClass">
  {{ message }}
  <span class="zef-color-primary-inverted" i18n>Click for more...</span>
</div>
